import type { BackfillJobKind, BackfillJobRead } from "@/types";

export const JOB_KIND_OPTIONS: Array<{ value: BackfillJobKind; label: string; interval: string }> = [
  { value: "OI_CHAIN_5MIN", label: "Option chain + index (5-minute)", interval: "5minute" },
  { value: "INDEX_CANDLES_1MIN", label: "Index candles (1-minute)", interval: "1minute" },
  { value: "OPTION_PRICES_1MIN", label: "Option prices (1-minute, for backtests)", interval: "1minute" },
];

/** Default strike band (± strikes) per kind: option prices are planned around the day's index range. */
export function defaultStrikeBand(kind: BackfillJobKind): number {
  return kind === "OPTION_PRICES_1MIN" ? 2 : 10;
}

export function intervalForKind(kind: BackfillJobKind): string {
  return JOB_KIND_OPTIONS.find((o) => o.value === kind)?.interval ?? "5minute";
}

/** Short label for the jobs table; flags legacy 1-minute OI jobs. */
export function jobDataLabel(job: Pick<BackfillJobRead, "job_kind" | "interval">): {
  label: string;
  legacy: boolean;
} {
  const kind = job.job_kind ?? "OI_CHAIN_5MIN";
  if (kind === "INDEX_CANDLES_1MIN") return { label: `Index candles · ${job.interval}`, legacy: false };
  if (kind === "OPTION_PRICES_1MIN") return { label: `Option prices · ${job.interval}`, legacy: false };
  return { label: `Option chain · ${job.interval}`, legacy: job.interval !== "5minute" };
}
